export const psColors = {
  nodeDefault: "#cccccc",
  nodeInactive: "#E9E9E9",
  nodeMuted: "#868686",
  linkDefault: "#999999",
  bgSubtle: "#FBFBFB",
} as const;
